import { Date } from 'core-js/web';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig } from '../../hooks';
import { formatDateAsync } from '../../utilities';

const DateTime = () => {
  const { dateTime } = useConfig();
  const [date, setDate] = React.useState('');
  const { i18n } = useTranslation();

  const dateFormat = dateTime && dateTime.format ? dateTime.format : 'EEEE dd MMM yyyy, h:mm aaa';

  React.useEffect(() => {
    const currentDate = new Date();

    formatDateAsync(currentDate, dateFormat, i18n.language)
      .then(formattedDate => setDate(formattedDate))
      .catch(() => setDate(format(currentDate, dateFormat)));
  }, [dateFormat, i18n.language]);

  return <span> {date}.</span>;
};

export default DateTime;
